module.exports = __webpack_public_path__ + "img/ansar.8d998162.png";